import React from 'react';

import { ConfigResponse } from '../../store/modules/merchant/types';
import PageWrapper from '../../common/PageWrapper';
import { useConfigUpsert } from '../../hooks';
import { useMerchant } from '../../contexts/MerchantContext';
import { PaylinkRecurringCheckboxContent } from './components/PaylinkRecurringCheckboxContent';
import { useGetConfigsQuery } from '../../store/modules/merchant/api';
import { toast } from '../../util/toast';
export const PaylinkConfigurations = () => {
  const { merchantId, isLoading: merchantInfoLoading, canUpdateMerchantSettings } = useMerchant();

  const hasModifyAccess = canUpdateMerchantSettings();

  const { onConfigUpsert, isLoading: isSaving } = useConfigUpsert(merchantId);
  const { data: configs, isLoading: isLoadingConfigs } = useGetConfigsQuery(merchantId, {
    skip: !merchantId,
  });
  const paylinksRecurringCheckboxConfig = configs?.find(
    (c) => c.name === 'PAYLINKS_RECURRING_CHECKBOX',
  ) as ConfigResponse<boolean> | undefined;

  return (
    <PageWrapper
      showParentHierarchyBanner
      data-testid="PAYLINKS_RECURRING_CHECKBOX"
      title="Paylinks Configurations"
      description="Use this page to configure your Paylinks."
      isLoading={isLoadingConfigs || merchantInfoLoading}
    >
      <PaylinkRecurringCheckboxContent
        key={`${merchantId}-${paylinksRecurringCheckboxConfig?.configId ?? 'new'}`}
        readOnly={!hasModifyAccess}
        isSaving={isSaving}
        paylinksRecurringCheckboxConfig={paylinksRecurringCheckboxConfig}
        onSave={async (paylinksRecurringCheckbox) => {
          try {
            await onConfigUpsert({
              enabled: true,
              name: 'PAYLINKS_RECURRING_CHECKBOX',
              value: paylinksRecurringCheckbox,
              configId: paylinksRecurringCheckboxConfig?.configId,
              merchantId: paylinksRecurringCheckboxConfig?.merchantId,
            });
            toast.success('Changes saved successfully');
          } catch {
            toast.error(
              'An error occurred while saving these changes. Please try again later or contact Skipify Support',
            );
          }
        }}
      />
    </PageWrapper>
  );
};
